export default __webpack_public_path__ + "static/media/WasteHandlingAndDisposal_bg.fb2c4b45.jpg";